export default __webpack_public_path__ + "static/media/trash-bin.acaa8900.svg";